import React from 'react';
import DataTile from "./DataTile";
import {useSelector} from "react-redux";
import {Col, Row} from "reactstrap";

const TileCloudIntegrationsData = ({queryType = null, icon = null}) =>{

    const { entityInView, cloudIntegrations, loadingCloudIntegrations, loadingCloudIntegrationsError, loadingCloudIntegrationData, loadingCloudIntegrationDataError} = useSelector(({breachrisk}) => breachrisk);

    const cloudOptions = cloudIntegrations && cloudIntegrations[entityInView] && cloudIntegrations[entityInView].options;
    const cloudIntegrationObjects = cloudIntegrations && cloudIntegrations[entityInView] && cloudIntegrations[entityInView].integrations;
    const cloudIntegrationData = cloudIntegrations && cloudIntegrations[entityInView] && cloudIntegrations[entityInView].integrations && cloudIntegrations[entityInView].integrationData;

    const queryData = cloudIntegrationData && cloudIntegrationData[queryType] ? cloudIntegrationData[queryType] : [];
    const hasError = loadingCloudIntegrationDataError && loadingCloudIntegrationDataError[entityInView] && loadingCloudIntegrationDataError[entityInView][queryType]

    const title = ()=>{
        return(
            <Row>
                <Col>
                    <h1 className={"text-center"}>
                        {queryType.charAt(0).toUpperCase().concat(queryType.substr(1).toLowerCase())}
                    </h1>
                </Col>
            </Row>

        )
    }

    const valueFunction = () => {

        const dataPointToDisplay = queryData ? queryData.length : null;

        return dataPointToDisplay;
    }

    // console.log("TILES, querydata for quertype", queryData, queryType)
    return(
        <DataTile
            subTitle={title()}
            tipText={`Number of elements found in cloud infrastructure associated with ${queryType}.`}
            icon={<div className={"animated fadeIn animation-duration-7"}>
                {icon}
        </div>}
            // stateName={"breachrisk"}
            // stateElement={"portfolios"}
            dontFetch
            forceLoadingState={loadingCloudIntegrationData && loadingCloudIntegrationData[entityInView] && loadingCloudIntegrationData[entityInView][queryType]}
            valueFunction={valueFunction}
        />
    )
}

export default TileCloudIntegrationsData;